import React, { useEffect, useState } from "react";
import VedioDetailBanner from "../../Components/VedioDetailBanner";
import MyNavbar from "../../Components/Navbar/Navbar";
import ReviewItem from "../../Components/ReviewItem.jsx";
import DetailItem from "../../Components/DetailItem";
import Footer from "../../Components/Footer/Footer";
import { Navbar2 } from "../../Components/Navbar2/Navbar2";
import BookDetailBanner from "../../Components/BookDetailBanner";
import HorizontalList from "../../Components/HorizontalList";
import {
  audioBookData,
  ebooksData,
  moviesData,
  musicData,
  seasonsData,
} from "../../Constant/Data";
import AudioPlayerComponent from "../../Components/AudioPlayerComponent";
import AudioDetailBanner from "../../Components/AudioDetailBanner";
import SeasonsList from "../../Components/SeasonsList";
import RatingAverage from "../../Components/RatingAverage";
import GiveRating from "../../Components/GiveRating";
import useDetail from "./useDetail";
import Loader from "../../Components/Loader";
import {
  getExtension,
  getYear,
  returnSubCategoryName,
} from "../../helper/helper";
import InfoModal from "../../Components/InfoModal";
import PlaylistComponent from "../../Components/PlayListComponent";
import SampleVideoModal from "../../Components/SampleVideoModal";
import useAdGate from "../../hooks/useAdGate";
import AdVideoModal from "../../Components/AdVideoModal";
import { useNavigate } from "react-router-dom";
import { getItemAccessType } from "../../helper/accessTypeHelper";
import FooterNew from "../../Components/LandingNew/FooterNew.jsx";
function DetailSkeleton() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 py-8 animate-pulse">
      {/* Banner Skeleton */}
      <div className="h-[55vh] bg-zinc-900/40 rounded-2xl border border-zinc-800/60 p-8 sm:p-12 mb-8 flex flex-col justify-center">
        <div className="h-4 w-24 bg-zinc-800/80 rounded mb-4 animate-pulse"></div>
        <div className="h-12 w-2/3 bg-zinc-800/80 rounded mb-6 animate-pulse"></div>
        <div className="h-4 w-1/2 bg-zinc-800/80 rounded mb-4 animate-pulse"></div>
        <div className="h-4 w-1/3 bg-zinc-800/80 rounded mb-8 animate-pulse"></div>
        <div className="flex gap-4">
          <div className="h-11 w-36 bg-zinc-800/80 rounded-lg animate-pulse"></div>
          <div className="h-11 w-36 bg-zinc-800/80 rounded-lg animate-pulse"></div>
        </div>
      </div>
      {/* Info Grid Skeleton */}
      <div className="py-8">
        <div className="h-8 w-48 bg-zinc-900/60 rounded mb-6 animate-pulse"></div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="h-16 bg-zinc-900/30 rounded-xl border border-zinc-850/40 flex justify-between items-center px-4">
              <div className="h-4 w-20 bg-zinc-800/60 rounded animate-pulse"></div>
              <div className="h-4 w-32 bg-zinc-800/60 rounded animate-pulse"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Detail() {
  const {
    playerRef,
    itemDetail,
    similarItems,
    similarItemsData,
    similarItemsLoading,
    itemLoading,
    data,
    open,
    width,
    handleOpen,
    loading,
    token,
    userData,
    isPlayerOpen,
    setIsPlayerOpen,
    onClickBuy,
    onWishClick,
    loginModal,
    modalConfig,
    handleLoginModal,
    onLoginClick,
    onSignupClick,
    togglePlayerOpen,
    featuredVideoModal,
    toggleFaturedVideoModal
  } = useDetail();
  const navigate = useNavigate();
  const {
    isAdModalOpen,
    adData,
    triggerWithAdGate,
    onAdCompleted,
    closeAdModal,
    isSubscribed,
  } = useAdGate();

  const [unlockedItemIds, setUnlockedItemIds] = useState(() => new Set());
  const [isPlayerVisible, setIsPlayerVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);

  const currentItem = itemDetail || data;
  const access = getItemAccessType(currentItem);
  const isPurchased = currentItem?.is_purchased;

  const currentId = currentItem?.id;
  const isItemSessionUnlocked = currentId ? unlockedItemIds.has(currentId) : false;

  const isAudioUnlocked =
    Boolean(isPurchased) ||
    Boolean(isSubscribed) ||
    !access.isFree ||
    isItemSessionUnlocked;

  const isEffectivelyAccessible =
    Boolean(isPurchased) || access.isFree || (access.isExclusive && isSubscribed);

  // Reset player dock state if user navigates to a new item
  useEffect(() => {
    setIsPlayerVisible(false);
    setIsPlaying(false);
  }, [currentItem?.id]);

  const handleWatchMovie = () => {
    if (!token) {
      handleLoginModal({
        actionType: "watch",
        title: "Sign In to Watch",
        itemTitle: currentItem?.title,
      });
      return;
    }

    triggerWithAdGate(itemDetail || data, () => {
      navigate("/Vedio", { state: { adCompleted: true } });
    });
  };

  const handleReadBook = () => {
    if (!token) {
      handleLoginModal({
        actionType: "read",
        title: "Sign In to Read",
        itemTitle: currentItem?.title,
      });
      return;
    }

    triggerWithAdGate(itemDetail || data, () => {
      navigate("/Ebook", { state: { adCompleted: true } });
    });
  };

  const handlePlayAudio = () => {
    const item = itemDetail || data;
    if (!item) return;

    if (!token) {
      handleLoginModal({
        actionType: "listen",
        title: "Sign In to Listen",
        itemTitle: currentItem?.title,
      });
      return;
    }

    // Check paywall/membership if item is not accessible
    if (!isEffectivelyAccessible) {
      if (access.isExclusive) {
        navigate("/Subscription");
      } else {
        onClickBuy();
      }
      return;
    }

    // If item is already unlocked (VIP / Purchased / Already watched ad in this session)
    if (isAudioUnlocked) {
      if (!isPlayerVisible) {
        setIsPlayerVisible(true);
        setIsPlaying(true);
      } else {
        const audioElement = playerRef.current?.audio?.current;
        if (audioElement) {
          if (isPlaying) {
            audioElement.pause();
          } else {
            audioElement.play().catch(() => { });
          }
        } else {
          setIsPlaying((prev) => !prev);
        }
      }
      return;
    }

    // Free item + Non-subscribed user: Must watch ad before audio is unlocked
    triggerWithAdGate(item, () => {
      const activeId = item?.id;
      if (activeId) {
        setUnlockedItemIds((prev) => {
          const next = new Set(prev);
          next.add(activeId);
          return next;
        });
      }
      setIsPlayerVisible(true);
      setIsPlaying(true);
    });
  };

  const categoryList = Array.isArray(currentItem?.category)
    ? currentItem.category
    : Array.isArray(data?.category)
      ? data.category
      : [];

  const categoryNames = categoryList
    .map((c) => (c?.name || "").toLowerCase())
    .join(" ");

  const rawType = (currentItem?.type || data?.type || "").toLowerCase();

  const isAudioBook =
    rawType === "audio_book" ||
    rawType === "audiobook" ||
    categoryNames.includes("audiobook") ||
    categoryNames.includes("audio book");

  const isMusic =
    !isAudioBook &&
    (rawType === "audio" ||
      rawType === "music" ||
      categoryNames.includes("music") ||
      categoryNames.includes("song"));

  const isAudioContent = isMusic || isAudioBook;
  const isMovie = rawType === "video" || rawType === "movie";
  const isPlaylist = rawType === "playlist";
  const isEbook = !isAudioBook && (rawType === "ebook" || rawType === "book");
  const isSeason = rawType === "season";

  const sub_category = returnSubCategoryName(
    currentItem?.sub_category || data?.sub_category
  );

  return (
    <div className="max-w-full min-w-full bab-new-bg min-h-screen text-white transition-colors duration-300">
      <Navbar2 />
      {itemLoading ? (
        <DetailSkeleton />
      ) : !itemDetail?.id ? (
        <div className="flex items-center justify-center h-[50vh] text-zinc-500 font-medium">
          No item details available.
        </div>
      ) : (
        <>
          {isMovie ? (
            <VedioDetailBanner
              {...(itemDetail || data)}
              onClickBuy={onClickBuy}
              onWishClick={onWishClick}
              isPurchased={isPurchased}
              width={width}
              onFeaturedClick={toggleFaturedVideoModal}
              onWatch={handleWatchMovie}
              dark={true}
            />
          ) : isPlaylist ? (
            <PlaylistComponent
              {...(itemDetail || data)}
              onClickBuy={onClickBuy}
              onWishClick={onWishClick}
              isPurchased={isPurchased}
              onPlayClick={handlePlayAudio}
              onFeaturedClick={toggleFaturedVideoModal}
              dark={true}
            />
          ) : isAudioBook ? (
            <BookDetailBanner
              {...(itemDetail || data)}
              onClickBuy={onClickBuy}
              onWishClick={onWishClick}
              isPurchased={isPurchased}
              onPlayClick={handlePlayAudio}
              onRead={handleReadBook}
              isAudioBook={true}
              isPlayerOpen={isPlaying}
              onFeaturedClick={toggleFaturedVideoModal}
              dark={true}
            />
          ) : isMusic ? (
            <AudioDetailBanner
              {...(itemDetail || data)}
              onClickBuy={onClickBuy}
              onWishClick={onWishClick}
              isPurchased={isPurchased}
              onPlayClick={handlePlayAudio}
              isPlayerOpen={isPlaying}
              onFeaturedClick={toggleFaturedVideoModal}
              dark={true}
            />
          ) : (
            <BookDetailBanner
              {...(itemDetail || data)}
              onClickBuy={onClickBuy}
              onWishClick={onWishClick}
              isPurchased={isPurchased}
              onPlayClick={handlePlayAudio}
              onRead={handleReadBook}
              isAudioBook={false}
              isPlayerOpen={isPlaying}
              onFeaturedClick={toggleFaturedVideoModal}
              dark={true}
            />
          )}

          {!similarItemsData?.length && !loading ? null : (
            <section className="px-4 py-6 sm:px-12 lg:px-20 lg:py-6 lg:pb-2">
              <HorizontalList
                autoScroll
                type={"Movies"}
                data={similarItemsData}
                title="More Like This"
                loading={similarItemsLoading}
                dark={true}
              />
            </section>
          )}

          <section className="mx-auto px-4 py-8 sm:px-10 lg:px-20 lg:py-10">
            <div className="flex items-center gap-3 mb-8">
              <span className="h-7 w-1 bg-secondary rounded-full"></span>
              <h2 className="text-xl font-bold tracking-tight text-white sm:text-3xl">
                More Information
              </h2>
            </div>
            <div className="rounded-2xl border bg-zinc-900/20 border-zinc-800/60 backdrop-blur-md p-6 sm:p-8 shadow-2xl">
              <dl className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                <DetailItem
                  title={"Name"}
                  value={itemDetail?.title || "Inception"}
                  dark={true}
                />
                <DetailItem
                  title={"Genres"}
                  value={sub_category || "Science Fiction"}
                  dark={true}
                />
                {itemDetail?.author && (
                  <DetailItem title={"Author"} value={itemDetail?.author} dark={true} />
                )}
                {itemDetail?.cast && (
                  <DetailItem title={"Cast"} value={itemDetail?.cast} dark={true} />
                )}
                {itemDetail?.rating && (
                  <DetailItem title={"Rating"} value={itemDetail?.rating} dark={true} />
                )}
                {itemDetail?.views && (
                  <DetailItem title={"Views"} value={itemDetail?.views} dark={true} />
                )}
                {itemDetail?.publish_date && (
                  <DetailItem
                    title={"Released Date"}
                    value={`${data?.released ||
                      itemDetail?.released_date ||
                      itemDetail?.publish_date
                      }`}
                    dark={true}
                  />
                )}
                {itemDetail?.pages && (
                  <DetailItem title={"Pages"} value={itemDetail?.pages} dark={true} />
                )}
                {itemDetail?.edition && (
                  <DetailItem title={"Edition"} value={itemDetail?.edition} dark={true} />
                )}
                {itemDetail?.description && (
                  <DetailItem
                    title={"Description"}
                    value={
                      itemDetail?.description ||
                      "No description available."
                    }
                    dark={true}
                    className="md:col-span-2"
                  />
                )}
              </dl>
            </div>
          </section>

          <FooterNew />

          {isAudioContent && isPlayerVisible && (
            <AudioPlayerComponent
              playerRef={playerRef}
              isPlayerOpen={isPlaying}
              setIsPlayerOpen={setIsPlaying}
              autoPlay={true}
              isUnlocked={isAudioUnlocked}
              onRequestAd={handlePlayAudio}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              onEnded={() => setIsPlaying(false)}
              {...itemDetail}
            />
          )}

          {loginModal && (
            <InfoModal
              handelModal={() => handleLoginModal(false)}
              onClose={() => handleLoginModal(false)}
              onLoginClick={onLoginClick}
              onSignupClick={onSignupClick}
              title={modalConfig?.title}
              message={modalConfig?.message}
              actionType={modalConfig?.actionType}
              itemTitle={currentItem?.title}
              dark={true}
            />
          )}

          {featuredVideoModal && (
            <SampleVideoModal
              vedioUrl={itemDetail?.feature_video}
              onClose={toggleFaturedVideoModal}
            />
          )}

          {/* Video Ad Interstitial Modal */}
          <AdVideoModal
            isOpen={isAdModalOpen}
            adData={adData}
            onComplete={onAdCompleted}
            onClose={closeAdModal}
          />
        </>
      )}
    </div>
  );
}

